export default __webpack_public_path__ + "static/media/NW0160.34I-36868_-21646_0.314e7e4e.jpg";